import React from 'react'; // 1. Se añade la importación de React
import { ReactComponent as usersIcon } from '../assets/icons/sucursal.svg';
import { ReactComponent as consultaEnvasesIcon } from '../assets/icons/envase.svg';
import { IconType } from 'react-icons';

// --- Interfaces ---

export interface SubMenuItemType {
  name: string;
  path: string;
}

export interface WidgetType {
  title: string;
  // 2. Se corrige el tipo para aceptar componentes SVG y de react-icons
  icon: IconType | React.FC<React.SVGProps<SVGSVGElement>>;
  statistic: string;
  description: string;
  path: string;
  color: string;
  interactionType?: 'focus';
  subItems?: SubMenuItemType[];
  submenuPosition?: 'left' | 'right';
}

// --- Datos ---

export const widgetData: WidgetType[] = [
  {
    title: 'Sucursales',
    icon: usersIcon, // Válido
    statistic: '',
    description: 'Sucursales',
    path: '/catalogos/sucursales-index',
    color: '#007bff',
  },
  {
    title: 'Tipo de envases',
    icon: consultaEnvasesIcon, // Válido
    statistic: '',
    description: 'Tipos de envases disponibles',
    path: '/catalogos/tipo-envase-index',
    color: '#fd7e14',
  },
  /*
    NOTA: El siguiente código está comentado porque faltan las importaciones de los iconos.
    Para descomentarlo, necesitarías importar 'catalogoIcon', 'reportesIcon', etc.
    de la misma manera que los otros.

    {
      title: 'Catálogos',
      icon: catalogoIcon,
      statistic: '89',
      description: 'Catálogos de productos',
      path: '/dashboard/catalogos',
      color: '#6f42c1',
      interactionType: 'focus',
      subItems: [
        { name: 'Fabricante', path: '/dashboard/catalogos/productos' },
        { name: 'Marca', path: '/dashboard/catalogos/servicios' },
        { name: 'Modelo', path: '/dashboard/catalogos/proveedores' },
      ],
    },
    // ... más widgets comentados
  */
];